import React from "react";
import { LinearProgress as MuiLinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  progressBar: (props) => ({
    "&.MuiLinearProgress-root": {
      height: "3px",
      backgroundColor: "#373737",
    },
    "& span": {
      "&.MuiLinearProgress-bar": {
        backgroundColor: props.color,
      },
    },
  }),
});

function LinearProgress(props) {
  const classes = useStyles(props);
  const { color, variant, value, ...others } = props;

  return (
    <>
      <MuiLinearProgress
        className={classes.progressBar}
        variant={variant || "determinate"}
        value={value}
        {...others}
      />
    </>
  );
}

export default LinearProgress;
